// 검색 카테고리 및 서브 카테고리 정의

export interface SubCategoryOption {
  id: string;
  label: string;
}

export interface SubCategory {
  id: string;
  label: string;
  type: 'select' | 'multiselect' | 'range' | 'time';
  options?: SubCategoryOption[];
}

export interface SearchCategory {
  id: string;
  label: string;
  subCategories: SubCategory[];
}

// 중고거래 카테고리
const usedGoodsCategory: SearchCategory = {
  id: 'used-goods',
  label: '중고거래',
  subCategories: [
    {
      id: 'item-category',
      label: '카테고리',
      type: 'select',
      options: [
        { id: 'digital', label: '디지털기기' },
        { id: 'appliances', label: '생활가전' },
        { id: 'furniture', label: '가구/인테리어' },
        { id: 'living', label: '생활/주방' },
        { id: 'baby', label: '유아동' },
        { id: 'baby-books', label: '유아도서' },
        { id: 'women-clothes', label: '여성의류' },
        { id: 'women-accessories', label: '여성잡화' },
        { id: 'men-fashion', label: '남성패션/잡화' },
        { id: 'beauty', label: '뷰티/미용' },
        { id: 'sports', label: '스포츠/레저' },
        { id: 'hobby', label: '취미/게임/음반' },
        { id: 'books', label: '도서' },
        { id: 'tickets', label: '티켓/교환권' },
        { id: 'food', label: '가공식품' },
        { id: 'health-food', label: '건강기능식품' },
        { id: 'pet', label: '반려동물용품' },
        { id: 'plants', label: '식물' },
        { id: 'other', label: '기타 중고물품' },
        { id: 'wanted', label: '삽니다' },
      ]
    },
    {
      id: 'price-range',
      label: '가격',
      type: 'select',
      options: [
        { id: 'free', label: '나눔' },
        { id: 'under-50', label: '50 AUD 이하' },
        { id: 'under-100', label: '100 AUD 이하' },
        { id: 'under-200', label: '200 AUD 이하' },
        { id: 'custom', label: '직접 입력' },
      ]
    }
  ]
};

// 부동산 카테고리
const realEstateCategory: SearchCategory = {
  id: 'real-estate',
  label: '부동산',
  subCategories: [
    {
      id: 'property-transaction',
      label: '거래 방식',
      type: 'select',
      options: [
        { id: 'sale', label: '매매' },
        { id: 'rent', label: '렌트' },
      ]
    },
    {
      id: 'property-listing-type',
      label: '매물 종류',
      type: 'select',
      options: [
        { id: 'house', label: '하우스' },
        { id: 'apartment', label: '아파트' },
        { id: 'townhouse', label: '타운하우스' },
        { id: 'unit', label: '유닛' },
        { id: 'villa', label: '빌라' },
        { id: 'studio', label: '스튜디오' },
        { id: 'land', label: '토지' },
        { id: 'granny_flat', label: '그래니 플랫' },
        { id: 'room', label: '룸' },
        { id: 'commercial', label: '상업용' },
        { id: 'short_term', label: '단기 숙소' },
      ]
    },
    {
      id: 'property-room-type',
      label: '방 형태',
      type: 'select',
      options: [
        { id: 'single', label: '룸(단독)' },
        { id: 'master', label: '마스터룸' },
        { id: 'twin', label: '트윈룸' },
        { id: 'shared', label: '룸(셰어)' },
        { id: 'female_only', label: '여성 전용' },
      ]
    },
    {
      id: 'property-price-period',
      label: '가격',
      type: 'select',
      options: [
        { id: 'weekly', label: '주세' },
        { id: 'monthly', label: '월세' },
      ]
    }
  ]
};

// 중고차 카테고리
const usedCarCategory: SearchCategory = {
  id: 'used-car',
  label: '중고차',
  subCategories: [
    {
      id: 'car-type',
      label: '차종',
      type: 'select',
      options: [
        { id: 'small', label: '경차/소형차' },
        { id: 'mid', label: '준/중형차' },
        { id: 'large', label: '준/대형차' },
        { id: 'suv', label: 'SUV/RV' },
        { id: 'van', label: '승합/화물차' },
        { id: 'other', label: '기타' },
      ]
    },
    {
      id: 'fuel-type',
      label: '연료',
      type: 'select',
      options: [
        { id: 'gasoline', label: '가솔린 (휘발유)' },
        { id: 'diesel', label: '디젤(경유)' },
        { id: 'lpg', label: 'LPG' },
        { id: 'hybrid-gas', label: '하이브리드 (가솔린+전기)' },
        { id: 'hybrid-diesel', label: '하이브리드 (디젤+전기)' },
        { id: 'hybrid-lpg-gas', label: '하이브리드 (LPG+가솔린)' },
        { id: 'hybrid-lpg-electric', label: '하이브리드 (LPG+전기)' },
        { id: 'cng', label: 'CNG (천연가스)' },
        { id: 'electric', label: '전기' },
        { id: 'hydrogen', label: '하이브리드 수소전기' },
      ]
    }
  ]
};

// 알바/구인 카테고리
const jobCategory: SearchCategory = {
  id: 'job',
  label: '알바/구인',
  subCategories: [
    {
      id: 'work-type',
      label: '근무 유형',
      type: 'select',
      options: [
        { id: 'long-term', label: '1개월 이상' },
        { id: 'short-term', label: '단기' },
      ]
    },
    {
      id: 'job-role',
      label: '하는일',
      type: 'select',
      options: [
        { id: 'serving', label: '서빙' },
        { id: 'kitchen-helper', label: '주방보조/설거지' },
        { id: 'chef', label: '주방장/조리사' },
        { id: 'sales', label: '매장관리/판매' },
        { id: 'barista', label: '음료 제조' },
        { id: 'baking', label: '베이킹' },
        { id: 'convenience', label: '편의점' },
        { id: 'moving', label: '짐 옮기기' },
        { id: 'cleaning', label: '업체청소' },
        { id: 'errand', label: '심부름/소일거리' },
        { id: 'flyer', label: '전단지 배포' },
        { id: 'tutoring', label: '과외/학원' },
        { id: 'daycare-helper', label: '등하원도우미' },
        { id: 'babysitting', label: '아이돌봄' },
        { id: 'pet-care', label: '반려동물 돌봄' },
        { id: 'elderly-care', label: '어르신 돌봄' },
        { id: 'housework', label: '가사/집정리' },
        { id: 'other', label: '기타' },
      ]
    },
    {
      id: 'work-days',
      label: '근무 요일',
      type: 'multiselect',
      options: [
        { id: 'mon', label: '월' },
        { id: 'tue', label: '화' },
        { id: 'wed', label: '수' },
        { id: 'thu', label: '목' },
        { id: 'fri', label: '금' },
        { id: 'sat', label: '토' },
        { id: 'sun', label: '일' },
      ]
    }
  ]
};

// 교민업체 카테고리
const localBusinessCategory: SearchCategory = {
  id: 'local-business',
  label: '교민업체',
  subCategories: [
    {
      id: 'business-category',
      label: '카테고리',
      type: 'select',
      options: [
        { id: 'food', label: '음식' },
        { id: 'cafe', label: '카페·디저트' },
        { id: 'beauty', label: '뷰티' },
        { id: 'hobby', label: '취미' },
        { id: 'hospital', label: '병원·약국' },
        { id: 'moving', label: '이사·용달' },
        { id: 'living', label: '생활' },
        { id: 'education', label: '교육' },
        { id: 'repair', label: '수리' },
        { id: 'sports', label: '운동' },
        { id: 'childcare', label: '육아' },
        { id: 'pet', label: '반려동물' },
        { id: 'hair-salon', label: '미용실' },
        { id: 'cleaning', label: '청소' },
        { id: 'laundry', label: '세탁소' },
        { id: 'interior', label: '인테리어시공' },
      ]
    },
    {
      id: 'benefits',
      label: '혜택',
      type: 'multiselect',
      options: [
        { id: 'coupon', label: '쿠폰' },
        { id: 'instant-booking', label: '바로예약' },
        { id: 'instant-payment', label: '바로결제' },
      ]
    }
  ]
};

// 동네톡톡 카테고리 (커뮤니티 토크)
const communityTalkCategory: SearchCategory = {
  id: 'community-talk',
  label: '동네 톡톡',
  subCategories: [
    {
      id: 'talk-category',
      label: '주제',
      type: 'select',
      options: [
        { id: 'all', label: '전체' },
        { id: 'restaurant', label: '맛집' },
        { id: 'event', label: '동네행사' },
        { id: 'pet', label: '반려동물' },
        { id: 'sports', label: '운동' },
        { id: 'convenience', label: '생활/편의' },
        { id: 'lost', label: '분실/실종' },
        { id: 'hospital', label: '병원/약국' },
        { id: 'story', label: '고민/사연' },
        { id: 'friends', label: '동네친구' },
        { id: 'moving', label: '이사/시공' },
        { id: 'housing', label: '주거/부동산' },
        { id: 'education', label: '교육' },
        { id: 'hobby', label: '취미' },
        { id: 'incident', label: '동네사건사고' },
        { id: 'scenery', label: '동네풍경' },
        { id: 'beauty', label: '미용' },
        { id: 'pregnancy', label: '임신/육아' },
        { id: 'general', label: '일반' },
      ]
    }
  ]
};

// 동네마켓 카테고리 (구 중고거래 통합)
const communityCategory: SearchCategory = {
  id: 'community',
  label: '동네마켓',
  subCategories: [
    {
      id: 'item-category',
      label: '카테고리',
      type: 'select',
      options: [
        { id: 'digital', label: '디지털기기' },
        { id: 'appliances', label: '생활가전' },
        { id: 'furniture', label: '가구/인테리어' },
        { id: 'living', label: '생활/주방' },
        { id: 'baby', label: '유아동' },
        { id: 'baby-books', label: '유아도서' },
        { id: 'women-clothes', label: '여성의류' },
        { id: 'women-accessories', label: '여성잡화' },
        { id: 'men-fashion', label: '남성패션/잡화' },
        { id: 'beauty', label: '뷰티/미용' },
        { id: 'sports', label: '스포츠/레저' },
        { id: 'hobby', label: '취미/게임/음반' },
        { id: 'books', label: '도서' },
        { id: 'tickets', label: '티켓/교환권' },
        { id: 'food', label: '가공식품' },
        { id: 'health-food', label: '건강기능식품' },
        { id: 'pet', label: '반려동물용품' },
        { id: 'plants', label: '식물' },
        { id: 'other', label: '기타 중고물품' },
        { id: 'wanted', label: '삽니다' },
      ]
    }
  ]
};

// 모임 카테고리
const meetupCategory: SearchCategory = {
  id: 'meetup',
  label: '모임',
  subCategories: [
    {
      id: 'meetup-category',
      label: '카테고리',
      type: 'select',
      options: [
        { id: 'all', label: '전체' },
        { id: 'sports', label: '운동' },
        { id: 'friends', label: '동네친구' },
        { id: 'outdoor', label: '아웃도어/여행' },
        { id: 'self-development', label: '자기계발' },
        { id: 'family', label: '가족/육아' },
        { id: 'pet', label: '반려동물' },
        { id: 'food', label: '음식/음료' },
        { id: 'hobby', label: '취미/오락' },
        { id: 'reading', label: '독서/인문학' },
        { id: 'culture', label: '문화/예술' },
        { id: 'music', label: '음악/악기' },
        { id: 'other', label: '기타' },
      ]
    }
  ]
};

// 뉴스 카테고리
const newsCategory: SearchCategory = {
  id: 'news',
  label: '뉴스',
  subCategories: []
};

// 동영상 카테고리
const videoCategory: SearchCategory = {
  id: 'video',
  label: '동영상',
  subCategories: []
};

// 핫딜 카테고리
const hotDealCategory: SearchCategory = {
  id: 'hot-deal',
  label: '핫딜',
  subCategories: [
    {
      id: 'deal-category',
      label: '카테고리',
      type: 'select',
      options: [
        { id: 'all', label: '전체' },
        { id: 'food', label: '음식/식료품' },
        { id: 'fashion', label: '패션/의류' },
        { id: 'beauty', label: '뷰티/화장품' },
        { id: 'electronics', label: '전자제품' },
        { id: 'home', label: '생활/주방' },
        { id: 'service', label: '서비스' },
        { id: 'other', label: '기타' },
      ]
    }
  ]
};

// 맛집 카테고리
const restaurantCategory: SearchCategory = {
  id: 'restaurant',
  label: '맛집',
  subCategories: [
    {
      id: 'cuisine-type',
      label: '음식 종류',
      type: 'select',
      options: [
        { id: 'all', label: '전체' },
        { id: 'korean', label: '한식' },
        { id: 'japanese', label: '일식' },
        { id: 'chinese', label: '중식' },
        { id: 'western', label: '양식' },
        { id: 'cafe', label: '카페/디저트' },
        { id: 'asian', label: '아시안' },
        { id: 'fusion', label: '퓨전' },
        { id: 'other', label: '기타' },
      ]
    },
    {
      id: 'price-range',
      label: '가격대',
      type: 'select',
      options: [
        { id: 'budget', label: '저렴 ($-$$)' },
        { id: 'mid', label: '보통 ($$-$$$)' },
        { id: 'premium', label: '고급 ($$$-$$$$)' },
      ]
    }
  ]
};

// 전체 카테고리
const allCategory: SearchCategory = {
  id: 'all',
  label: '전체',
  subCategories: []
};

export const searchCategories: SearchCategory[] = [
  allCategory,
  communityCategory,
  realEstateCategory,
  usedCarCategory,
  jobCategory,
  localBusinessCategory,
  communityTalkCategory,
  meetupCategory,
  newsCategory,
  videoCategory,
  hotDealCategory,
  restaurantCategory,
];

// Alias for backward compatibility
export const allSearchCategories = searchCategories;

export function getCategoryById(id: string): SearchCategory | undefined {
  return searchCategories.find(cat => cat.id === id);
}
